module.exports = __webpack_public_path__ + "img/billie_2024_10_23.87c870d.svg";